import React, { useMemo , useState , useEffect } from "react";
import { useTable, usePagination } from "react-table";
import { useSelector } from "react-redux";
import styles from "./interestVendor.module.css";
import { Column, data } from "./Column";
import { fetchInterestVendor } from "../../Api/Ecom";


function IntrestVendor() {
  const token = useSelector(state => state.login.token);
  const [interestVendor, setInterestVendor] = useState([])

    const memoizedColumns = useMemo(() => Column(), []);
    const memoizedData = useMemo(() => interestVendor, []);
 
  useEffect(() => {
    const getInterestVendor = async () => {
      try {
        const result = await fetchInterestVendor(token);
        setInterestVendor(result.data.requests.map(e=>e.requester));
        console.log(result.data.requests.map(e=>e.requester))
      } catch (error) {
        console.log(error)
      }
    }
    getInterestVendor();
  }, [memoizedData])

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    nextPage,
    previousPage,
    pageOptions,
    state: { pageIndex },
  } = useTable(
    {
      columns: memoizedColumns,
      data: memoizedData,
      initialState: { pageIndex: 0, pageSize: 9 },
    },
    usePagination
  );

  return (
      <div className={styles.container}>
      <div className={styles.tableTab}>
        <h4>Interested Vendor</h4>
      </div>

      <table {...getTableProps()} className={styles.table} id="customers">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()} key={column.id}>
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.length > 0 ? (
            page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} key={row.id}>
                  {row.cells.map((cell) => {
                    return (
                      <td {...cell.getCellProps()} key={cell.column.id}>
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={memoizedColumns.length}>No Data Available</td>
            </tr>
          )}
        </tbody>
      </table>
      <div className={styles.moveButton}>
        <button
          type="button"
          className={styles.button}
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          Previous
        </button>

        <button
          type="button"
          className={styles.button}
          onClick={() => nextPage()}
          disabled={!canNextPage}
        >
          Next
        </button>
        <span className={styles.page}>
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>
        </span>
      </div>
      <span className={styles.pagePhone}>
          Page{" "}
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>
        </span>
    </div>
  );
}

export default IntrestVendor;
